import { render } from "./DebugAuth.vue?vue&type=template&id=efd58b2e"
import script from "./DebugAuth.vue?vue&type=script&lang=js"
export * from "./DebugAuth.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__